import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { SearchFormOptions } from '../../../types/recruitments';
import { getSearchFormOptions } from '../../../services/recruitments';
import { useLoginRegisterModals } from '../../../hooks/useLoginRegisterModals';
import { useFlash } from '../../../hooks/useFlash';

type Props = {
  isRecruitmentShowPage: boolean;
  requestUrl: string;
  logoPc: string;
  logoSp: string;
  isVantan: boolean;
  isSearchPage: boolean;
  isLoginError?: boolean;
  requireLogin?: boolean;
  modalFlashMessage?: string;
  lineIcon: string;
  flash?: boolean;
  flashType?: string;
  flashMessage?: string;
};

export const Component: FunctionComponent<Props> = ({
  isRecruitmentShowPage,
  requestUrl,
  logoPc,
  logoSp,
  isVantan,
  isSearchPage,
  isLoginError,
  requireLogin,
  modalFlashMessage,
  lineIcon,
  ...props
}) => {
  const { flash, flashType, flashMessage, handleFlash } = useFlash();

  useEffect(() => {
    if (props.flash) {
      handleFlash(props.flash, props.flashType || '', props.flashMessage || '');
    }
  }, []);

  const [query, setQuery] = useState('');
  const [targetEmploymentTypes, setTargetEmploymentTypes] = useState([]);
  const [targetOccupations, setTargetOccupations] = useState([]);
  const [targetPrefectureDetails, setTargetPrefectureDetails] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchFormOptions, setSearchFormOptions] = useState<SearchFormOptions>({} as SearchFormOptions);

  const {
    isLoginModalOpen,
    isRegisterModalOpen,
    handleToggleLoginModal,
    handleToggleRegisterModal,
    handleChangeModal,
    redirectUrl,
    isRecruitmentOrEventOrTvOrCompanyPath
  } = useLoginRegisterModals(false);

  useEffect(() => {
    if ((isLoginError && sessionStorage.getItem('login_modal_from_button') === 'header') || requireLogin) {
      handleToggleLoginModal();
    }
  }, []);

  useEffect(() => {
    const request = async () => {
      try {
        const response = await getSearchFormOptions();
        setSearchFormOptions(response);
      } catch (error) {
        console.log(error);
      }
    };

    if (isRecruitmentShowPage) {
      $('.l-spbottom').hide();
    }
    request();
  }, [isRecruitmentShowPage]);

  const handleChangeQuery = (event: any) => {
    const target = $(event.currentTarget);
    const value = $(target).val();
    setQuery(value);
  };

  const handleMenuPlan = (event: any) => {
    $('.l-spbottom').toggleClass('open');
    $('.l-spbottom__menu').toggleClass('open');
    $('.l-spbottom--bg').toggleClass('open');
    handleToggleLoginModal();
  };

  const handleToggleModal = () => {
    if (!isModalOpen) {
      $('html, body').css('overflow', 'hidden');
    } else {
      $('html, body').removeAttr('style');
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleClear = () => {
    setQuery('');
    setTargetEmploymentTypes([]);
    setTargetOccupations([]);
    setTargetPrefectureDetails([]);
  };

  const getCurrentData = (name: string) => {
    if (name === 'target_employment_types') {
      return targetEmploymentTypes;
    }
    if (name === 'target_occupations') {
      return targetOccupations;
    }
    if (name === 'target_prefecture_details') {
      return targetPrefectureDetails;
    }
  };

  const handleChange = (name: string, array: any) => {
    const newState = array.filter(Boolean);
    if (name === 'target_employment_types') {
      setTargetEmploymentTypes(newState);
    }
    if (name === 'target_occupations') {
      setTargetOccupations(newState);
    }
    if (name === 'target_prefecture_details') {
      setTargetPrefectureDetails(newState);
    }
  };

  const handleClick = (event: any) => {
    const target = $(event.currentTarget);
    const value = $(target.children()[0]).attr('value') as string;
    const name = $(target.children()[0]).attr('name') as string;
    const current = getCurrentData(name) as any[];
    if ($.inArray(value.split(',')[0], current) > -1) {
      const valueArray = value.split(',');
      const array = current.filter((i: any) => valueArray.indexOf(i) === -1);
      handleChange(name, array);
    } else {
      const array = current.concat(value.split(','));
      handleChange(
        name,
        array.filter((element, index) => array.indexOf(element) === index)
      );
    }
  };

  return (
    <Presentation
      lineIcon={lineIcon}
      isRecruitmentShowPage={isRecruitmentShowPage}
      requestUrl={requestUrl}
      logoPc={logoPc}
      logoSp={logoSp}
      isVantan={isVantan}
      isSearchPage={isSearchPage}
      searchFormOptions={searchFormOptions}
      isModalOpen={isModalOpen}
      query={query}
      targetEmploymentTypes={targetEmploymentTypes}
      targetOccupations={targetOccupations}
      targetPrefectureDetails={targetPrefectureDetails}
      isLoginModalOpen={isLoginModalOpen}
      isRegisterModalOpen={isRegisterModalOpen}
      redirectUrl={redirectUrl}
      isLoginError={isLoginError}
      modalFlashMessage={modalFlashMessage}
      handleChangeQuery={handleChangeQuery}
      handleClick={handleClick}
      handleClear={handleClear}
      handleMenuPlan={handleMenuPlan}
      handleToggleModal={handleToggleModal}
      handleToggleLoginModal={handleToggleLoginModal}
      handleToggleRegisterModal={handleToggleRegisterModal}
      handleChangeModal={handleChangeModal}
      isRecruitmentOrEventOrTvOrCompanyPath={isRecruitmentOrEventOrTvOrCompanyPath}
      flash={flash}
      flashType={flashType}
      flashMessage={flashMessage}
      handleFlash={handleFlash}
    />
  );
};
